import useEvent from '../event';
import useRingSettings from './useRingSettings';

export const useRingThemeCustomization = eventUniqueName => {
    const event = useEvent(eventUniqueName);
    const { data } = useRingSettings(event?.data?.id, event?.data?.accountId, {
        enabled: !!event.data,
    });
    return data?.customization;
};

export default useRingThemeCustomization;
